import { render, staticRenderFns } from "./ChooseBar.vue?vue&type=template&id=29822012&"
import script from "./ChooseBar.vue?vue&type=script&lang=js&"
export * from "./ChooseBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports